export default {
      id: "snmp-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.dd84271a.svg#snmp",
      toString: function () {
        return this.url;
      }
    }